import { Component, Inject, OnInit } from "@angular/core";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";

const DEFAULT_ORIGINAL_URI = window.location.origin;

@Component({
  selector: "wcg-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  standalone: false,
})
export class LoginComponent implements OnInit {
  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {}

  ngOnInit(): void {
    this.startLoginFlow();
  }

  private async startLoginFlow(): Promise<void> {
    const originalUri = this.oktaAuth.getOriginalUri();

    if (!originalUri || originalUri === DEFAULT_ORIGINAL_URI) {
      this.oktaAuth.setOriginalUri("/");
    }

    try {
      await this.oktaAuth.signInWithRedirect();
    } catch (err) {
      console.error("Error during Okta redirect", err);
    }
  }
}
